import { isAndroid, isContactPickerSupported, isIOS } from './inviteContacts';

export function getContactImportPlatform() {
  if (isIOS()) return 'ios';
  if (isAndroid()) return 'android';
  return 'desktop';
}

/** Which import methods to show for the current device. */
export function getContactImportOptions() {
  const platform = getContactImportPlatform();

  return {
    platform,
    google: true,
    phonePicker: platform === 'android' && isContactPickerSupported(),
    vCard: platform === 'ios',
  };
}
